export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/quick-search`,
        name: `${prefix}.quick-search.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.quick-search.index`,
                PageDescription: "Inventory management: Inventory quick search",
            },
        },
    },
    {
        path: `/${prefix}/inventory/create`,
        name: `${prefix}.inventory.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.inventory.create`,
                PageDescription: "Inventory management: Add Inventory",
            },
        },
    },
];